// extracted by mini-css-extract-plugin
export var cardIcon = "_af-5";
export var cardIconUnframed = "_af-9";
export var checkboxCard = "_af-0";
export var checkboxCardSelected = "_af-4";
export var disabled = "_af-2";
export var interactive = "_af-1";
export var outerBorder = "_af-3";
export var spacerMedium = "_af-8";
export var spacerSmall = "_af-7";
export var spacerXsmall = "_af-6";